import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class userSection_template extends vnTemplate{

    protected getTemplateHtml(): string{

        return `
             <a data-bind="attr: { href: getProfileUrl() }" class="main-nav-link icon i-user"><span><span class="user-name" data-bind="html: formatUserNameAction() "></span><span class="user-role" data-bind="html: getRoleName()"></span></span></a>
                <!--<img data-bind="attr:{src: user().user.vnAppUser.pictureUrl}" alt="">-->
                <!--<strong><span data-bind="text: formatUserNameAction"></span></strong>-->
                <!--<p data-bind="text: user().roles[0].name"></p>-->
                <!--<ul class="user-pro-list">-->
                    <!--&lt;!&ndash; ko foreach: user().channels &ndash;&gt;-->
                        <!--<li class="user-prop-item" data-bind="css: iconImage"></li>-->
                    <!--&lt;!&ndash; /ko &ndash;&gt;-->
                <!--</ul>-->
            
            `;
    }

    protected getTemplateName(): string{
        return "userSection-template";
    }


    protected getMainElementClasses(): Array<string>{
        return ["user-section"];
    }

    protected buildViewModel(): any{
        let huit_neuf_this = this;

        return {
            formatUserNameAction: ko.pureComputed(function () { return huit_neuf_this.formatUserName(); }),
            getRoleName: ko.pureComputed(function () { return huit_neuf_this.getRoleName(); }),
            getProfileUrl: ko.pureComputed(function () { return huit_neuf_this.getProfileUrl(); }),
            user: ko.observableArray([]),
        };
    }

    public setUser(user: any){
        this.viewModel[this.idElement].user(user);
    }

    private formatUserName(){
        let user = this.viewModel[this.idElement].user();
        return user.user.vnAppUser.firstName + ' ' + user.user.vnAppUser.lastName;
    }
    private getProfileUrl(){
        let user = this.viewModel[this.idElement].user();
        return '/user/profile/' + user.user.id;
    }

    private getRoleName() {
        let user = this.viewModel[this.idElement].user();
        return user.user.vnAppUser.roles[0].name;
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/userSection_template.ts